<template>
  <div>
    <button
      v-for="tab in tabs"
      :key="tab.label"
      type="button"
      class="btn btn-tab btn-tab-sm"
      :disabled="selectedTab == tab.value ? true : false"
      @click="handleTabChange(tab.value === premix ? brand: tab.value)"
      :class="
        selectedTab == (tab.value === premix ? brand: tab.value)
          ? 'active selected-tab'
          : ''" >
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      tabs: [
        {
          value: "Active",
          label: this.$resourceString["account.Header.Active.Projects"]
        },

        {
          value: "Archived",
          label:this.$resourceString["account.Header.Archived.Projects"]
        },
        {
          value: "Shared",
          label: this.$resourceString["myProject.Project.SharedProjects.Title"]
        },
      ],
      isButtonActive: false,
      premix: this.$resourceString['common.accounts.Label.Premix'],
      brand: this.$resourceString['common.accounts.Label.Brand'],
      shared: this.$resourceString['common.accounts.Label.Shared'],
      active: this.$resourceString['common.accounts.Label.Active'],
    };
  },
  computed: {
    ...mapGetters({
      selectedTab: "myTray/getselectedTabName"
    })
  },

  methods: {
    ...mapActions({
      updateTabName: "myTray/updateTabName"
    }),

    updateUrlQueryParam(tabName) {
      const url = new URL(window.location);
      url.searchParams.set("tab", tabName.toLowerCase());
      window.history.replaceState(
        null,
        null,
        url.origin + url.pathname + "?" + url.searchParams
      );
    },

    handleTabChange(tabName) {
      this.updateUrlQueryParam(tabName === this.brand ? this.premix : tabName);
      this.updateTabName(tabName);
    }
  },

  mounted() {
    const url = new URL(window.location);
    let currentTab = this.tabs.find(
      e =>
        (e.value.toLowerCase() == this.shared
          ? this.shared
          : e.value.toLowerCase()) == url.searchParams.get("tab")
    );
    let tabName = this.active;
    if (currentTab) {
      tabName = currentTab.value;
    } else {
      this.updateUrlQueryParam(tabName);
    }
    this.updateTabName(tabName === this.premix ? this.brand : tabName);
  }
};
</script>
